import { Grid } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";
// import InsertChartTwoToneIcon from '@material-ui/icons/InsertChartTwoTone';
import GraphIcon from '@material-ui/icons/DonutSmall';
import EditIcon from '@material-ui/icons/Edit';
import ListIcon from '@material-ui/icons/List';
import NotesIcon from '@material-ui/icons/Notes';
import SearchIcon from "@material-ui/icons/Search";
import NotFeasibleIcon from '@material-ui/icons/ThumbDown';
import DesignIcon from '@material-ui/icons/ThumbUp';
import React, { useEffect, useState } from "react";
// import { getProcessedReports } from "../apis/tasks";
import { Doughnut, Bar } from 'react-chartjs-2';
import { getProcessedReports, getSubmissionsByTaskId } from "../apis/submissionsitems";
import { updateTask } from "../apis/tasks";
import { EFFORT, PRIORITY, STATUS, RUNSTATUS } from '../constants';
import './dnd.css';
import './icons.css';
import { LightTooltip } from "./LightTooltip";
import Loading from "./Loading";
import useStyles from "./muistyles";
import { Table } from "./GenericReusableComponents/Table"

import {SelectEnvironment} from "./GenericReusableComponents/HTMLWrappers"

import {SelectDuration} from "./GenericReusableComponents/HTMLWrappers"


import { getBotDeploymentConfigByEnv, getBotExceptionsByEnv, getBotSchedulesByEnv} from "../apis/bots";
import { getAgentsByEnvironment} from "../apis/agents";



export default function Analytics(props) {
  const [selection, setSelection] = useState(3)

  const [processReports, setProcessReports] = useState([]);
  const [filteredProcessReports, setFilteredProcessReports] = useState([]);
  const [q, setQ] = useState("");
  const [showAddProcessReportForm,setShowAddProcessReportForm] = useState(false);
  const [showDelProcessReportModal,setShowDelProcessReportModal] = useState(false);
  const [taskTobeDel,setProcessReportTobeDel] = useState({});
  const [taskTobeUpdt,setProcessReportTobeUpdt] = useState({});
  const [showUpdtProcessReportModal,setShowUpdtProcessReportModal] = useState(false);
  const [processReportsChanged,setProcessReportsChanged] = useState(false);
  const [refreshToggle,setRefreshToggle] = useState(false);
  const [graphicalView,setGraphicalView] = useState(true);
  const [tableView,setTableView] = useState(true);
  const [loading, setLoading] = useState(true);
  const [processItemInEdit,setProcessItemInEdit] = useState({});

  const [depProfile, setDepProfile] = useState(0) 
  const [botsDeployed, setBotsDeployed] = useState(0) 
  const [numAgents, setNumAgents] = useState(0) 
  const [numExceptions, setNumExceptions] = useState(0) 
  const [numSchedules, setNumSchedules] = useState(0) 


  const[selectedEnv,setSelectedEnv] = useState("PROD");
  const[selectedDuration,setSelectedDuration] = useState("WEEK");

  const designerIconStyle = {
    backgroundImage:'linear-gradient(to bottom, grey, royalblue)', color:'white', padding:'5px', borderRadius:'10px'
  }

  const classes = useStyles();
  
  
  useEffect(() => {
    console.log("Inside Process Reports UseEffect");
    let mounted = true;
    if(processReports.length && !processReportsChanged){
      console.log("processReportsChanged :"+processReportsChanged)
      return;
    }
  
   
      console.log("Calling getProcessedReports");
    setLoading(true);    
    getData(selectedEnv);

    return () => {console.log("ProcessReport is unmounted"); mounted = false};
  }, [processReports, processReportsChanged, selectedEnv]);


  function getData(env) {
    getBotDeploymentConfigByEnv(env).then((profileList)=>{
      setDepProfile (profileList.length)
      const botList = profileList.map((profile) => profile.botName);
      const botSet = new Set(botList)
      setBotsDeployed(botSet.size)
      getAgentsByEnvironment(env)
      .then((agents) => {
        const agentsLength = agents.length;
        console.log("Length of the array:", agentsLength);
        setNumAgents(agentsLength)
      })
      .catch((error) => {
        console.error("Error fetching agents:", error);
        // Handle the error appropriately
      });

      getBotExceptionsByEnv(env).then(exceptions => {
        setNumExceptions(exceptions.length)
      })

      // getBotSchedulesByEnv(env).then(schedules => {
      //   setNumSchedules(schedules.length)
      // })
      setLoading(false);    


    })  

  }

  function onSelectEnv(e){
    e.preventDefault();
    console.log(`onSelectEnv ${e.target.value}`)
    setSelectedEnv(e.target.value);

}

function onSelectDuration(e){
  e.preventDefault();
  console.log(`onSelectEnv ${e.target.value}`)
  setSelectedDuration(e.target.value);
  // getData(e.target.value);

}




  function getTableHeader(){
    return(
      <>
      <LightTooltip title="Bot Name">
      <th>Bot Name</th>
      </LightTooltip>
     

      <LightTooltip title="Total Number of Runs Past Month">
      <th>Times Run</th>
      </LightTooltip>
      <LightTooltip title="Number Of Successful Runs Past Month">
      <th>Successful Runs</th>
      </LightTooltip>
      <LightTooltip title="Average Duration of Run Past Month">
      <th>Av. Duration</th>
      </LightTooltip>

      <LightTooltip title="Equivalent Human cost per hour">
      <th>Rate</th>
      </LightTooltip>

      <LightTooltip title="Total Savings Past Month">
      <th>Savings</th>
      </LightTooltip>

      <LightTooltip title="Business Criticality">
      <th>Criticality</th>
      </LightTooltip>
    </>
    )
  }

  function getTableBody(){
    return (

      filteredProcessReports.map((processItem) => (
        <tr>
          <td>{processItem.taskName}</td>
          
          {/* <td>{processItem.startDate}</td>

          <td>{processItem.endDate}</td> */}
          <td>{processItem.submissions}</td>
          <td>{processItem.userCount}</td>
          <td>{processItem.timeTaken}</td>
          <td>{processItem.frequency}</td>
          <td>{"$" + processItem.costperhour}</td>
          <td>{ processItem.annualCostDollars == undefined? "(TBD)": "$" + processItem.annualCostDollars  + " (" + processItem.annualCostTime + " hrs)" }</td>
          <td>{getPriority(processItem)}</td>
          <td>{getEffort(processItem)}</td>
          <td>{processItem.status}</td>
          <td style={{width : "200px"}}>
         
           {getActions(processItem)}
          </td>
        </tr>
      ))
    )
  }


  function refreshView(){
    console.log("refresh view "+refreshToggle);
    if(refreshToggle == false)
      setRefreshToggle(true);
    else
      setRefreshToggle(false);
  }


  function filterTable(filterString) {
    console.log(filterString);
    let trimStr = filterString.trim();
    if (trimStr === "") {
      setFilteredProcessReports(processReports);
      setQ("");
    } else {
      setQ(filterString);
      setFilteredProcessReports(
        processReports.filter((task) => {
          if (task.taskName.startsWith(filterString)) return true;

          if (task.description.startsWith(filterString)) return true;

          if (task.priority.startsWith(filterString)) return true;


          if (task.status.startsWith(filterString)) return true;

          console.log("no match ");
          console.dir(task);
        })
      );
    }
  }

  function setProcessItemsChangedTrigger(bool){
    console.log("setProcessItemsChanged "+bool)
    setProcessReportsChanged(bool);
  }



  function promoteToDesign(e, processItem){
    processItem.status = STATUS.PROMOTED.string;
    let task = {};
    task.taskId = processItem.taskId;
    task.taskName = processItem.taskName;
    task.status = processItem.status;
    task.description = processItem.description;
    task.endDate = processItem.endDate;
    task.priority = processItem.priority;
    task.userCount = processItem.userCount;
    task.costperhour = processItem.costperhour;
    updateTask(task);
    // setProcessReportsChanged(true);
    updateProcessItemState(processItem);
  }

  function reject(e, processItem){
    processItem.status = STATUS.REJECTED.string;
    // let task = {};
    // task.taskId = processItem.taskId;
    // task.taskName = processItem.taskName;
    // task.status = processItem.status;
    // task.description = processItem.description;
    // task.endDate = processItem.endDate;
    // task.priority = processItem.priority;
    // task.userCount = processItem.userCount;
    // task.costperhour = processItem.costperhour;
    let task = getTaskFromProcessItem(processItem);
    updateTask(task);
    // setProcessReportsChanged(true);
    updateProcessItemState(processItem);

    // setProcessReportsChanged(true);


  }

  function getTaskFromProcessItem(processItem){
    let task = {};
    task.taskId = processItem.taskId;
    task.taskName = processItem.taskName;
    task.status = processItem.status;
    task.description = processItem.description;
    task.endDate = processItem.endDate;
    task.priority = processItem.priority;
    task.userCount = processItem.userCount;
    task.costperhour = processItem.costperhour;
    return task;
  }

  function notes(e, processItem){
    
  }


  function setShow(bool){
    setShowAddProcessReportForm(bool);
  }

  function setShowDel(bool){
    setShowDelProcessReportModal(bool);
  }

  function setShowUpdt(bool){
    setShowUpdtProcessReportModal(bool);
  }
  //temporarily duplicating the code. reuse later
  function getStatusStyle(status){
    var statusStyle = "status";
    switch (status){
      case "INACTIVE":
        statusStyle = statusStyle + " statusInactive";
        break;
      case "DISABLED":
        statusStyle = statusStyle + " statusDisabled";
        break;

      default: statusStyle = statusStyle + " statusActive"
    }
    return statusStyle;
  }

  function getToolTipForThumbUp(processItem){
    if(processItem.status === "Active"){
      return "Move to Planning";
    }

    if(processItem.status === "Planning"){
      return "Move to Design";
    }

    if(processItem.status === "Planning"){
      return "Move to Promoted";
    }


  }

  function prioritySelected(e,processItem){
    // processItem.makeRowEditable = false;
    // processItem.priority = e.target.value;
    let lprocessInEdit = {...processItemInEdit};
    lprocessInEdit.priority = e.target.value;
    setProcessItemInEdit(lprocessInEdit);
    // updateProcessItemState(processItem);
  }

  function getPriority(processItem){
    if(processItem.makeRowEditable){
      return (
        <Select defaultValue={processItem.priority} onChange={(e)=>prioritySelected(e,processItem)}>
        <MenuItem value="CRITICAL" >CRITICAL</MenuItem>
        <MenuItem value="HIGH">HIGH</MenuItem>
        <MenuItem value="MEDIUM">MEDIUM</MenuItem>  
        <MenuItem value="LOW">LOW</MenuItem>      
      </Select>
      )
    }else{
      return processItem.priority;
      
    }
  }

  function effortSelected(e,processItem){
    let lprocessInEdit = {...processItemInEdit};
    lprocessInEdit.effort = e.target.value;
    setProcessItemInEdit(lprocessInEdit);
    
  }

  function getEffort(processItem){
    if(processItem.makeRowEditable){

      return (
        <Select defaultValue={processItem.effort} onChange={(e)=>effortSelected(e,processItem)}>
            <MenuItem value="SMALL" >SMALL</MenuItem>
            <MenuItem value="MEDIUM">MEDIUM</MenuItem>
            <MenuItem value="LARGE">LARGE</MenuItem>       
          </Select>
      )

    }else{
      return processItem.effort;
      
    }


  }

  function updateProcessItemState(processItem){
    var lprocessReports = [...processReports];
    let i = lprocessReports.findIndex((p)=>p.taskId === processItem.taskId)
    lprocessReports[i] = {...processItem};
    setFilteredProcessReports(lprocessReports);
    setProcessReports(lprocessReports);
    
  }

  function handleClickOnEdit(e,processItem){
    processItem.makeRowEditable = true;
    setProcessItemInEdit({...processItem});
    updateProcessItemState(processItem);
    
  }

  function update(e,processItem){
    
    var lprocessItemInEdit = {...processItemInEdit};
    lprocessItemInEdit.makeRowEditable = false;
    updateProcessItemState(lprocessItemInEdit);
    let task = {};
    task = getTaskFromProcessItem(lprocessItemInEdit);
    task.effort = lprocessItemInEdit.effort;
    task.priority = lprocessItemInEdit.priority;

    updateTask(task);
   
   
    setProcessItemInEdit({});
  }

  function cancel(e,processItem){
   
    processItem.makeRowEditable = false;
    updateProcessItemState(processItem);
    setProcessItemInEdit({});
  }


  function getActions(processItem){
    if(processItem.makeRowEditable){
      return (
        <>
      <LightTooltip title="Update">
        <IconButton  onClick={(e)=>update(e,processItem)}>
          <DoneIcon  />
        </IconButton>
      </LightTooltip>

      <LightTooltip title="Cancel">
        <IconButton  onClick={(e)=>cancel(e,processItem)}>
          <CloseIcon  />
        </IconButton>
      </LightTooltip>
      </>
      )
    }else{
      return (
        <>
        <LightTooltip title="Promote">
        <IconButton  onClick={(e)=>promoteToDesign(e,processItem)}>
          <DesignIcon  />
        </IconButton>
        </LightTooltip>

        <LightTooltip title="Reject">
        <IconButton  onClick={(e)=>reject(e,processItem)}>
          <NotFeasibleIcon />
        </IconButton>
        </LightTooltip>

        <LightTooltip title="Edit Effort">
        <IconButton  onClick={(e)=>handleClickOnEdit(e,processItem)}>
          <EditIcon />
        </IconButton>
        </LightTooltip>

        <LightTooltip title="Notes">
        <IconButton className='iconblue' onClick={(e)=>notes(e,processItem)}>
          <NotesIcon/>
        </IconButton>
        </LightTooltip>
        </>
      )
    }
  }

 



   

   if(graphicalView){
     console.log("Inside graphical view");

    
    
    let stats = [];
    for (let i = 0; i < 12; i++) { //initialize
      stats.push(0);
    }

    if(processReports.length != 0){
        stats = processReports.reduce((newArr,task)=>{
        if(task.status === STATUS.REJECTED.string){
            newArr[STATUS.REJECTED.value] =  newArr[STATUS.REJECTED.value]+ 1;
            return newArr;
        }

        if(task.effort === undefined){
          newArr[EFFORT.NOEFFORT.value] = newArr[EFFORT.NOEFFORT.value] + 1;
        }
        if(task.effort === EFFORT.SMALL.string){
          newArr[EFFORT.SMALL.value] = newArr[EFFORT.SMALL.value] + 1;
        }
        if(task.effort === EFFORT.MEDIUM.string){
          newArr[EFFORT.MEDIUM.value] = newArr[EFFORT.MEDIUM.value] + 1;
        }
  
        if(task.effort === EFFORT.LARGE.string){
          newArr[EFFORT.LARGE.value] =  newArr[EFFORT.LARGE.value]+ 1;
        }
  
        if(task.priority === PRIORITY.CRITICAL.string){
          newArr[PRIORITY.CRITICAL.value] =  newArr[PRIORITY.CRITICAL.value]+ 1;
        }
  
        if(task.priority ===  PRIORITY.HIGH.string){
          newArr[PRIORITY.HIGH.value] =  newArr[PRIORITY.HIGH.value]+ 1;
          
        }
  
        if(task.priority === PRIORITY.MEDIUM.string){
  
          newArr[PRIORITY.MEDIUM.value] =  newArr[PRIORITY.MEDIUM.value]+ 1;
          
        }
  
        if(task.priority === PRIORITY.LOW.string){
          newArr[PRIORITY.LOW.value] =  newArr[PRIORITY.LOW.value]+ 1;
          
        }
  
        if(task.status === "Active"){ //TODO change it enum
          newArr[STATUS.ACTIVE.value] =  newArr[STATUS.ACTIVE.value]+ 1;
        }
  
        if(task.status === STATUS.PLANNING.string){
          newArr[STATUS.PLANNING.value] =  newArr[STATUS.PLANNING.value]+ 1;
          
        }
  
        if(task.status === STATUS.PROMOTED.string){
          newArr[STATUS.PROMOTED.value] =  newArr[STATUS.PROMOTED.value]+ 1;
          
        }
  
       
  
        return newArr;
      },stats)
    }   
  
    console.log("Stats "+ JSON.stringify(stats));
    console.log(stats[EFFORT.SMALL.value]);
  
    const title1 = "Most Used Bots"
    const data1 = {
      labels: ['First', 'Second', 'Third', 'Fourth'],
      datasets: [
        {
          label: 'Dataset 1',
          // data: Utils.numbers(NUMBER_CFG),
          // data:[stats[EFFORT.SMALL.value], stats[EFFORT.MEDIUM.value], stats[EFFORT.LARGE.value],stats[EFFORT.NOEFFORT.value]],
          data:[40, 20, 10,5],
          backgroundColor:['royalblue', '#8da5ed', 'lavender','#feb100']
          // backgroundColor: Object.values(Utils.CHART_COLORS),
        }
      ]
    };


    
    const title2 = "Most Used Average Run Time";
    const data2 = {
      labels: ['First', 'Second', 'Third', 'Fourth'],
      datasets: [
        {
          label: 'Dataset 1',
          // data: Utils.numbers(NUMBER_CFG),
          // data:[stats[PRIORITY.CRITICAL.value], stats[PRIORITY.HIGH.value], stats[PRIORITY.MEDIUM.value],stats[PRIORITY.LOW.value]],
          data:[60, 30, 20,10],
          backgroundColor:['royalblue', '#8da5ed', 'lavender','#feb100']
          // backgroundColor: Object.values(Utils.CHART_COLORS),
        }
      ]
    };
  
    const title3 = "Transactions By Status"
    const data3 = {
      labels: ['Sucessful', 'Failed'],
      datasets: [
        {
          label: 'Dataset 1',
          // data: Utils.numbers(NUMBER_CFG),
          // data:[stats[RUNSTATUS.SUCCESS.value], stats[RUNSTATUS.FAILURE.value]],
          data:[90, 10],
          backgroundColor:['royalblue', '#8da5ed', 'lavender','#feb100']
          // backgroundColor: Object.values(Utils.CHART_COLORS),
        }
      ]
    };

    

  
    var data4=data1
    var data5=data2
    var data6=data3


    const renderCards = ()=>{
      return (
    <>
    <div class='row' style={{margin: 'auto', width: '80%', padding: '10px'}}>

        <div className='analyticscard'>
        <h5>Deployments</h5>
        <label>
          {depProfile}
          </label>
          
        </div>

        <div className='analyticscard'>
            <h5>Bots Deployed </h5>
            
            <label>
              {botsDeployed}               
            </label>

          </div>

          <div className='analyticscard'>
            <h5>Agents</h5>
            
            <label>
              {numAgents}               
            </label>

          </div>

          <div className='analyticscard'>
          <h5>Schedules</h5>
          <label>
              {numSchedules}               
            </label>
          </div>

          <div className='analyticscard'>
            <h5>Exceptions</h5>
            <label>
              {numExceptions}               
            </label>

          </div>




        {/* <div className='analyticscard'>
          <h5>Time Savings </h5>
          <label>
              2000 hours               
            </label>
            
          </div>

          <div className='analyticscard'>
          <h5>Cost Savings</h5>
          <label>
              $20,000               
            </label>
            
          </div> */}

          </div>
        </>




      )
    }

    return (
      <div>
        <div class='row' style={{margin: 'auto',width: '20%', padding: '10px'}}>
        <SelectEnvironment selectedEnv={selectedEnv} onChangeHandler={onSelectEnv}/>
        <SelectDuration selectedDuration={selectedDuration} onChangeHandler={onSelectDuration}/>
        </div>
        <Loading loading = {loading}></Loading>


      <Paper className={classes.donutpaper}>
        <LightTooltip title="Tabular view">
          <IconButton
            variant="contained"
            color="primary"
            size="medium"
            className={classes.iconbutton}
            onClick={() => {
              setTableView(true);
              setGraphicalView(false);
            }}
          >
            <ListIcon fontSize="large" style={designerIconStyle} />
          </IconButton>
        </LightTooltip>
        {/* <p/>
        <label style={{padding:'5px', backgroundColor:'#bababa', color:'white', fontSize:'18px'}}>{props.processName}</label>
        <p/> */}
        {renderCards()}

        <div id="chart" className="chart-container">
          <div>
            <h3 className="title">{title1}</h3>
            <Doughnut data={data1} />
          </div>
  
          <div>
            <h3 className="title">{title2}</h3>
            <Doughnut data={data2} />
          </div>
  
          <div>
            <h3 className="title">{title3}</h3>
            <Doughnut data={data3} />
          </div>
        </div>

        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        
        <div id="chart2" className="chart-container">

          <div>
            <h3 className="title">{title1}</h3>
            <Bar data={data4} />
          </div>
  
          <div>
            <h3 className="title">{title2}</h3>
            <Bar data={data5} />
          </div>
  
          <div>
            <h3 className="title">{title3}</h3>
            <Bar data={data6} />
          </div>
        </div>


      </Paper>
      </div>
    );
  }    
 if(tableView) {
  return (
    
      // <Paper elevation={1} className={classes.paper}>
     
      //    {/* <div style={{marginLeft:'6%',marginRight:'2%'}}> */}
      <>
        <Loading loading={loading}/>

          
          <LightTooltip title="Graphical view">
          <IconButton variant="contained"
            color="primary" size="medium" className={classes.iconbutton} onClick={()=>{
              setGraphicalView(true);
              setTableView(false); 
              }}>
            {/* <InsertChartTwoToneIcon fontSize="large"/> */}
            <GraphIcon fontSize="large" style={designerIconStyle}/>
          </IconButton>
          </LightTooltip>
         
        {/* <p/>
        <label style={{padding:'5px', backgroundColor:'#bababa', color:'white', fontSize:'18px'}}>{props.processName}</label>
        <p/> */}

            <div style={{marginLeft:'200px'}}>
              <Table 
                search={filterTable} 
                columns={getTableHeader()} 
                rows={getTableBody()}
                tbcontainerstyle={{margin:'0px',padding:'0px'}}
                // loading={loading}
              
                />
              </div>
              


  
    {/* </div> */}
    
  </>
    );
  }


}